import React, {useState, useEffect} from 'react'
import Navbar from '../components/Navbar'
import PreNav from '../components/PreNav'
import Footer from '../components/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { deleteItem } from '../redux/actions/cartAction'

const Cart = () => {

  const dispatch = useDispatch()
  const {cartItems} = useSelector(state=>state.cart)
  const [totalPrice, setTotalPrice] = useState(0)

  const totalPriceHandler = () => {
    let total = 0
    cartItems.map((item)=>{
      total += (item.variant_price * item.quantity)
    })
    setTotalPrice(total)
  }

  useEffect(() => {
    if (cartItems) { 
      totalPriceHandler()
    }
  }, [cartItems])

  const removeItemHandler = (id) => {
    dispatch(deleteItem(id))
  }

  const handleCheckout = () => {
    localStorage.setItem("checkoutItems", JSON.stringify(cartItems) )
    document.getElementById("checkoutAnchorTag").click()
  }

  return (
    <>
    <PreNav/>
    <Navbar/>
    <nav className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ol className="breadcrumb mb-md-0 font-size-xs text-gray-400">
              <li className="breadcrumb-item">
                <a className="text-gray-400" href="/">Home</a>
              </li>
              <li className="active">
                <i className='bi bi-chevron-right px-3'></i>
                Cart
              </li>
            </ol>
          </div>
        </div>
      </div>
    </nav>
    <section className="pt-7 pb-12">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Heading */}
              <h3 className="mb-10 text-center">Shopping Cart</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-7">
              {/* List group */}
              <ul className="list-group list-group-lg list-group-flush-x mb-6">
              {cartItems.length !== 0 ? 
                  cartItems.map((item, index)=>(
                    <li className="list-group-item">
                    <div className="row align-items-center">
                      <div className="col-3">
                        {/* Image */}
                        <a href={`/collections/framed-art/products/${item.handle}`}>
                          <img src={item.variant_image} alt="..." className="img-fluid" />
                        </a>
                      </div>
                      <div className="col">
                        {/* Title */}
                        <div className="d-flex mb-2 font-weight-bold">
                          <a className="text-body" href={`/collections/framed-art/products/${item.handle}`}>{item.title}</a> <span className="ml-auto">Rs. {item.variant_price}</span>
                        </div>
                        {/* Text */}
                        <p className="mb-7 font-size-sm text-muted">
                          {item.option1_name}: {item.option1_value} <br />
                          {item.option2_name}: {item.option2_value}
                        </p>
                        {/*Footer */}
                        <div className="d-flex align-items-center">
                          {/* Select */}
                          <select className="custom-select custom-select-xxs w-auto">
                            <option value={1}>1</option>
                            <option value={1}>2</option>
                            <option value={1}>3</option>
                          </select>
                          {/* Remove */}
                          <a className="font-size-xs text-gray-400 ml-auto cursor-pointer" onClick={()=>removeItemHandler(item._id)}>
                            <i className="fe fe-x" /> Remove
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  ))
                : <p>Cart is empty</p> }
              </ul>
              {/* Footer */}
              <div className="row align-items-end justify-content-between mb-10 mb-md-0">
                <div className="col-12 col-md-7">
                  {/* Coupon */}
                  <form className="mb-7 mb-md-0">
                    <label className="font-size-sm font-weight-bold" htmlFor="cartCouponCode">
                      Coupon code:
                    </label>
                    <div className="row form-row">
                      <div className="col">
                        {/* Input */}
                        <input className="form-control form-control-sm" id="cartCouponCode" type="text" placeholder="Enter coupon code*" />
                      </div>
                      <div className="col-auto">
                        {/* Button */}
                        <button className="btn btn-sm btn-dark" type="submit">
                          Apply
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-12 col-md-auto">
                  {/* Button */}
                  <button className="btn btn-sm btn-outline-dark">Update Cart</button>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5 col-lg-4 offset-lg-1">
              {/* Total */}
              <div className="card mb-7 bg-light">
                <div className="card-body">
                  <ul className="list-group list-group-sm list-group-flush-y list-group-flush-x">
                    <li className="list-group-item d-flex font-size-lg font-weight-bold">
                      <span>Total</span> <span className="ml-auto font-size-sm">Rs {totalPrice}</span>
                    </li>
                    <li className="list-group-item font-size-sm text-center text-gray-500">
                      Shipping cost calculated at Checkout *
                    </li>
                  </ul>
                </div>
              </div>
              {/* Button */}
              <button className="btn btn-block btn-dark mb-2" onClick={handleCheckout}>Proceed to Checkout</button>
              {/* Link */}
              <a className="btn btn-link btn-sm px-0 text-body" href="/collections/framed-art">
                <i className="bi bi-arrow-left mr-2" /> Continue Shopping
              </a>
            </div>
          </div>
        </div>
      </section>
      <a href="/checkout" id='checkoutAnchorTag' className="d-none"></a>
      <Footer/>
    </>

  )
}

export default Cart